module.exports = __webpack_public_path__ + "static/media/loupe.f7f85821.svg";